<div class="position-relative h-100">
	@if (avpState === "Loading" || avpState === "LoadingFailed") {
		<img
			style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; position: absolute; top: 0px; left: 0px"
			[src]="settings.waitingForVideoUrl"
		/>
	}

	@if (avpState === "Offline") {
		<img
			style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; position: absolute; top: 0px; left: 0px"
			[src]="settings.offlineVideoUrl"
		/>
	}

	@if (avpState === "Reconnecting" || avpState === "ReconnectingFailed") {
		<img
			style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; position: absolute; top: 0px; left: 0px"
			[src]="settings.reconnectingUrl"
		/>
	}

	@if (avpState === "Idle") {
		<img
			style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; position: absolute; top: 0px; left: 0px"
			[src]="settings.noVideoUrl"
		/>
	}

	@if (avpState === "Unauthorized") {
		<img
			style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; position: absolute; top: 0px; left: 0px"
			[src]="settings.unauthorizedUrl"
		/>
	}

	<div>
		<video #axisVideo style="width: 100%; height: 100%" autoplay [muted]="true"></video>
		@if (settings.axisVideoPlayerEnableDebugWindow) {
			<div
				class="axis-video-player-debug-container"
				[style.height.px]="debugContainerHeight"
				[ngClass]="{'hide-scrollbar': debugContainerHeight <= 40}"
			>
				{{ axisMediaStreamLibraryVideoOptions?.ipAddress }}
				<button
					class="camera-debug-button"
					mat-icon-button
					(click)="toggleDebugStatistics()"
					matTooltip="{{ T.SHARED_AXIS_MEDIA_STREAM_LIBRARY_DEBUG_INFORMATION | translate }}"
					matTooltipClass="accent"
				>
					<mat-icon> info</mat-icon>
				</button>
				<br />
				@if (showDebugStatistics) {
					Profile: {{ videoStreamStatistic?.codec?.profile }}<br />
					Level: {{ videoStreamStatistic?.codec?.level }}<br />
					Latency: {{ videoStreamStatistic?.latency }}ms<br />
					Dropped Frames: {{ videoStreamStatistic?.droppedFrames }}<br />
					Dropped Segments: {{ videoStreamStatistic?.droppedVideoSegments }}<br />
					Playback-Rate: {{ videoStreamStatistic?.playbackRate }}
					<!-- Speed up indicator -->
					@if (videoStreamStatistic?.playbackRate >= 1.05) {
						<i class="fas fa-angle-double-up"></i>
					}
					<br />
					WSUri: <small>{{ websocketUri }}</small
					><br />
					RTSPUri: <small>{{ rtspUri }}</small>
				}
			</div>
		}
	</div>
</div>
